import { SurfboardOrderPaymentData } from '@up/data';

export const isOrderPaymentDoneBySurfboard = (payment: any):
        {isSurfboardPayment: boolean, props?: {surfboardOrderId: string, surfboardMerchantId: string, surfboardTerminalId: string}} => {
  const surfboardDbData = payment.data as unknown as SurfboardOrderPaymentData;

  if (!surfboardDbData) {
    return {
      isSurfboardPayment: false
    }
  }

  const surfboardOrderId = surfboardDbData.orderId;
  const surfboardMerchantId = surfboardDbData.merchantId;
  const surfboardTerminalId = surfboardDbData.terminalId;

  console.log(`surfboardOrderId: ${surfboardOrderId}, surfboardMerchantId: ${surfboardMerchantId}, surfboardTerminalId: ${surfboardTerminalId}`);

  return {
    isSurfboardPayment : !!surfboardOrderId && !!surfboardMerchantId && !!surfboardTerminalId,
    props: { surfboardOrderId, surfboardMerchantId, surfboardTerminalId}
  };
}